import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, SITE_NAME } from './Seo';
import { getTestimonials } from '../services/api';

const INSTAGRAM = process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/skyleaftravelss';

// Site-wide business schema — present on every page, independent of each
// page's own <Seo> title/description/canonical tags. The aggregateRating
// below is computed from whatever testimonials actually exist in the
// database (real count, real average) rather than a fabricated number —
// Google's structured-data guidelines explicitly prohibit invented review
// counts, and this stays accurate automatically once placeholder
// testimonials are swapped for real ones.
export default function OrganizationJsonLd() {
  const [reviewStats, setReviewStats] = useState(null);

  useEffect(() => {
    getTestimonials()
      .then((testimonials) => {
        if (!testimonials?.length) return;
        const avg = testimonials.reduce((sum, t) => sum + (t.rating || 0), 0) / testimonials.length;
        setReviewStats({ count: testimonials.length, average: Math.round(avg * 10) / 10 });
      })
      .catch(() => {});
  }, []);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'TravelAgency',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/images/logo.jpg`,
    image: `${SITE_URL}/images/hero-meghalaya.jpg`,
    description:
      'Northeast India travel specialists based in Guwahati, Assam — Meghalaya, Kaziranga, Arunachal Pradesh, and beyond. Honest pricing, handpicked itineraries.',
    areaServed: 'Northeast India',
    sameAs: [INSTAGRAM],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Guwahati',
      addressRegion: 'Assam',
      addressCountry: 'IN'
    },
    ...(reviewStats && {
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: reviewStats.average,
        reviewCount: reviewStats.count,
        bestRating: 5
      }
    })
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
